export const PERMISSIONS_URL = 'https://qa-permissions.etherspot.io';

export enum KeyStore {
    AWS = 'AWS',
    TEE = 'TEE',
}

export const bufferPercent = 13; // Buffer in percent


export enum CALL_TYPE {
    SINGLE = "0x00",
    BATCH = "0x01",
    STATIC = "0xFE",
    DELEGATE_CALL = "0xFF"
  }
  
  export enum EXEC_TYPE {
    DEFAULT = "0x00",
    TRY_EXEC = "0x01"
  }

export const AddressZero = "0x0000000000000000000000000000000000000000";
